import { useResourcesQuery } from 'lib/generated';
import { groupBy } from 'lodash';
import { ListItem, UnorderedList, Box, Text, Center } from '@chakra-ui/react';
import { ResourceCategory } from '@inspire/data/schemas/resources';
import Link from 'components/general/Link';
import Spinner from '@inspire/ui/chakra/Spinner';
import {
  GTM_CATEGORY_RESSOURCES,
  GTM_ACTION_TELECHARGEMENT_RESSOURCE,
  pushEvent,
} from 'lib/gtm';

const CategoryItem = ({ description, resources }) => (
  <Box>
    <Text dangerouslySetInnerHTML={{ __html: description }} />
    <UnorderedList>
      {resources?.map((r, key) => (
        <ListItem key={key}>
          <Link
            href={r.url}
            target="_blank"
            onClick={() => {
              pushEvent(
                GTM_CATEGORY_RESSOURCES,
                GTM_ACTION_TELECHARGEMENT_RESSOURCE,
                r.name
              );
            }}
          >
            {r.name} :
          </Link>{' '}
          {r.description}
        </ListItem>
      ))}
    </UnorderedList>
  </Box>
);

const FichesActivitesProf = () => {
  const { data, isLoading } = useResourcesQuery();
  const categories = (data && groupBy(data.resources, 'category')) || {};
  return (
    <Box>
      {isLoading && (
        <Center>
          <Spinner size="xl" thickness="4px" my={8} />
        </Center>
      )}
      {
        <CategoryItem
          description={ResourceCategory.fiches.description}
          resources={categories.fiches}
        />
      }
    </Box>
  );
};

export default FichesActivitesProf;
